export default class Users {
    id?: string;
    firstName: string;
    lastName: string;
    email: string;
    enabled: boolean;
    roles: string[];

    constructor(id: string,firstName: string, lastName: string, email: string, enabled: boolean, roles: string[]) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.enabled = enabled; 
        this.roles = roles;
    } 
}